import { type FC, type PropsWithChildren } from 'react'
import styled from 'styled-components'

import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

type TakeoverUnifiedBoxBaseProps = PropsWithChildren<{
  hasTakeover: boolean
  background: string
}>

const UnifiedBoxWrapper = styled.div<{ $hasTakeover: boolean; $background: string }>(
  ({ theme, $hasTakeover, $background }) => `
  ${
    $hasTakeover
      ? `
    ${MEDIA_QUERIES(theme).large} {
      position: relative;
      z-index: 2;
      isolation: isolate;
      background: ${$background};
      border-radius: ${theme.borderRadius.small};
      box-shadow: 0 0.4rem 1.2rem rgb(0 0 0 / 15%);
      max-width: 1440px;
      margin-left: auto;
      margin-right: auto;
      margin-top: 4rem;
      pointer-events: auto;
    }
  `
      : ''
  }
`
)

export const TakeoverUnifiedBoxBase: FC<TakeoverUnifiedBoxBaseProps> = ({
  children,
  hasTakeover,
  background,
}) => {
  return (
    <UnifiedBoxWrapper $hasTakeover={hasTakeover} $background={background}>
      {children}
    </UnifiedBoxWrapper>
  )
}
